import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import { addNewTenantMembers, setModal } from '../../../../../../data/actions'
import { AsyncPaginate } from 'react-select-async-paginate'
import Select, { components } from 'react-select'
import { findUsers } from '../../../../../../http'

const UserForm = ({
  tenantRoles,
  onCancel,
  currentTenantMembers,
  selectedTenant,
  dispatchModal,
  addNewMembers,
  header,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([])
  const [members, setMembers] = useState([])
  const [search, setSearch] = useState('')
  const rolesObject = {}
  const roles = tenantRoles.map(({ name, description }) => {
    rolesObject[name] = description
    return {
      label: description,
      value: name,
      color: '#00B8D9',
      isFixed: true,
    }
  })

  const generateSelectOption = (user) => {
    const { firstName, lastName, daimlerId, email } = user
    return {
      value: daimlerId,
      label: `${firstName} ${lastName} (${daimlerId}${
        email ? ' - ' + email : ''
      })`,
      color: '#00B8D9',
      isFixed: true,
    }
  }

  const memberDaimlerIds = currentTenantMembers.map(
    ({ daimlerId }) => daimlerId,
  )

  async function loadOptions(_, loadedOptions) {
    const size = 20
    const page = Math.ceil(loadedOptions.length / size)

    const response =
      search && (await findUsers(search.toLowerCase(), page, size))

    const users = response?.content
      .filter((user) => !memberDaimlerIds.includes(user.daimlerId))
      .map(generateSelectOption)

    return {
      options: users || [],
      hasMore: !response?.last,
    }
  }

  const onSubmit = () => {
    addNewMembers(
      {
        tenantAcr: selectedTenant,
        daimlerIds: members.map(({ value }) => value),
        roles: selectedRoles.map(({ value }) => value),
        tenantUserRoleExpiryDate: moment().add(90, 'days').format('YYYY-MM-DD'),
      },
      () => dispatchModal({}),
    )
  }

  const MultiValueLabel = (props) => (
    <span title={'Customise your multi-value container!'}>
      <components.MultiValueLabel
        {...props}
        children={props.children.split(' (')[0]}
      />
    </span>
  )

  return (
    <div className="add-user-form">
      <div>
        {header && <wb-modal-content headline={header} />}
        <div className="wb-margin-top-xs">
          <AsyncPaginate
            isMulti
            inputValue={search}
            debounceTimeout={300}
            onInputChange={(value, { action }) => {
              if (action === 'set-value') {
                setSearch('')
              }
              setSearch(value)
            }}
            className="autocomplete"
            classNamePrefix="as"
            placeholder="Select users"
            loadOptions={loadOptions}
            value={members}
            onChange={setMembers}
            loadOptionsOnMenuOpen={false}
            closeMenuOnSelect={false}
            components={{
              MultiValueLabel,
            }}
          />
        </div>
        <div className="wb-margin-top-xs">
          <Select
            value={selectedRoles}
            isMulti
            name="roles"
            closeMenuOnSelect={false}
            options={roles}
            placeholder="Select roles"
            className="autocomplete"
            classNamePrefix="as"
            onChange={(roles) => setSelectedRoles(roles)}
          />
        </div>
      </div>
      <wb-modal-footer>
        <button
          type="button"
          onClick={onCancel}
          className="wb-button wb-button--secondary wb-button--small"
        >
          Cancel
        </button>
        <button
          disabled={!(members.length && selectedRoles.length)}
          type="button"
          onClick={onSubmit}
          className="wb-button wb-button--primary wb-button--small"
        >
          Add users
        </button>
      </wb-modal-footer>
    </div>
  )
}

UserForm.propTypes = {
  tenantRoles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  currentTenantMembers: PropTypes.arrayOf(
    PropTypes.shape({
      daimlerId: PropTypes.string,
    }),
  ),
  selectedTenant: PropTypes.string,
  header: PropTypes.string,
  dispatchModal: PropTypes.func,
  onCancel: PropTypes.func,
  addNewMembers: PropTypes.func,
}
export const AddUserForm = connect(
  ({
    tenants: { tenantRoles, currentTenantMembers, selectedTenant },
    roles: { users },
  }) => ({
    tenantRoles,
    users,
    selectedTenant,
    currentTenantMembers,
  }),
  { addNewMembers: addNewTenantMembers, dispatchModal: setModal },
)(UserForm)
